<p class="p1"
   data-cs-mask>{{email}}</p>